import React, { useEffect } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';

const ReferralsApprovalsChart = ({ isMonthlyView, monthlyData, yearlyData }) => {
  const dataToDisplay = isMonthlyView ? monthlyData : yearlyData;
  const xAxisKey = isMonthlyView ? 'month' : 'year';

  useEffect(() => {
  }, [dataToDisplay]);

  return (
    <div className="w-full h-[250px] overflow-x-auto scrollbar-hide md:overflow-x-visible">
      <div className="min-w-[500px] md:min-w-full h-full">
        <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={dataToDisplay}
          margin={{
            top: 20,
            right: 10,
            left: 10,
            bottom: 5,
          }}
        >
          <CartesianGrid
            stroke="#000000"
            horizontal={false}
            vertical={true}
            verticalCoordinatesGenerator={({ xAxis }) => {
              const { scale } = xAxis;
              const coordinates = [];

              if (scale && scale.domain && typeof scale.bandwidth === 'function') {
                const domain = scale.domain();
                domain.forEach((tick) => {
                  const x = scale(tick) + scale.bandwidth() / 2;
                  coordinates.push(x);
                });
              }

              return coordinates;
            }}
          />
          <XAxis
            dataKey={xAxisKey}
            stroke="#cbd5e0"
            tickLine={false}
            axisLine={{ stroke: "#cbd5e0" }}
            interval={0}
          />
          <YAxis
            stroke="#cbd5e0"
            tickLine={false}
            axisLine={{ stroke: "#cbd5e0" }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#1a202c',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
            }}
            itemStyle={{ color: '#fff' }}
          />
          <Bar dataKey="referrals" fill="#ffd000" name="Referrals" />
          <Bar dataKey="approved" fill="#0eb052" name="Approved" />
        </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ReferralsApprovalsChart;
